import React from 'react'
import './Iconos.css'
import { FaCog } from 'react-icons/fa'

const IconoConfiguracion = (props) => {
    return <span className={"icono-mp" + (props.background ? " background-configuracion" : "")}><FaCog /></span>
}

export default IconoConfiguracion